import { render, staticRenderFns } from "./childdealerinfo.vue?vue&type=template&id=5ecbb576&"
import script from "./childdealerinfo.vue?vue&type=script&lang=js&"
export * from "./childdealerinfo.vue?vue&type=script&lang=js&"
import style0 from "./childdealerinfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports